module.exports = __webpack_public_path__ + "img/offline11.09d6f648.png";